async function requestJson(path, options = {}) {
  const response = await fetch(path, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
    },
    ...options,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(data.message || `Request failed (${response.status})`);
    err.reasons = data.reasons;
    throw err;
  }
  return data;
}

export async function fetchVehicleDiscoveries(filters = {}) {
  const params = new URLSearchParams();
  if (filters.vehicleSourceId) params.set("vehicle_source_id", filters.vehicleSourceId);
  if (filters.discoveryStatus) params.set("discovery_status", filters.discoveryStatus);
  if (filters.city) params.set("city", filters.city);
  if (filters.department) params.set("department", filters.department);
  if (filters.search) params.set("search", filters.search);
  if (filters.discoveredFrom) params.set("discovered_from", filters.discoveredFrom);
  if (filters.discoveredTo) params.set("discovered_to", filters.discoveredTo);
  if (filters.limit) params.set("limit", String(filters.limit));
  const query = params.toString();
  const data = await requestJson(
    `/api/admin/mobility/vehicle-discoveries${query ? `?${query}` : ""}`
  );
  return data.discoveries || [];
}

export async function runVehicleSourceDiscovery(sourceId, payload = {}) {
  return requestJson(
    `/api/admin/mobility/vehicle-sources/${encodeURIComponent(sourceId)}/run-discovery`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  );
}

export async function patchVehicleDiscoveryStatus(id, discoveryStatus) {
  const data = await requestJson(
    `/api/admin/mobility/vehicle-discoveries/${encodeURIComponent(id)}`,
    {
      method: "PATCH",
      body: JSON.stringify({ discoveryStatus }),
    }
  );
  return data.discovery;
}
